import offsetImg3 from "../../assets/img/PremiumPrintingPack.png";
import offsetImg2 from "../../assets/img/PremiumWedingPack.png";
import offsetImg1 from "../../assets/img/FuneralPremium.png";


export const premiumPacksLinks = [
    {
        title: "Premium Birthday Bundle",
        description: "Helps you manage all your printing needs on a HIGH CLASS BUDGET. Click bellow to see what is contained in this pack and order now.",
        imgUrl: offsetImg3,
        link: "https://selar.co/7hr6",
    },
    {
        title: "Premium Wedding Bundle",
        description: "Helps you manage all your printing needs on a HIGH CLASS BUDGET. Click bellow to see what is contained in this pack and order now.",
        imgUrl: offsetImg2,
        link: "https://selar.co/ghw6",
    },
    {
        title: "Premium Funeral Bundle",
        description: "Helps you manage all your printing needs on a HIGH CLASS BUDGET. Click bellow to see what is contained in this pack and order now.",
        imgUrl: offsetImg1,
        link: "https://selar.co/vk2i",
    },
   
  ];